/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {SettlementsMainPageComponent} from './settlements-main-page.component';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';
import {TableModule} from '../../shared/table/table.module';
import {CommonModule} from '@angular/common';
import {PaginationModule} from '../../shared/pagination/pagination.module';
import {CodeFilterModule} from '../../shared/filter/code-filter/code-filter.module';
import {DateFilterModule} from '../../shared/filter/date-filter/date-filter.module';
import {InputAndCodeFilterModule} from '../../shared/filter/input-and-code-filter/input-and-code-filter.module';
import {NumberFilterModule} from '../../shared/filter/number-filter/number-filter.module';
import {SettlementDetailModule} from '../settlement-detail/settlement-detail.module';
import {SegmentedButtonModule} from '../../shared/segemented-button/segmented-button.module';

@NgModule({
    declarations: [SettlementsMainPageComponent],
    imports: [
        LoadingSpinnerModule,
        TableModule,
        CommonModule,
        PaginationModule,
        CodeFilterModule,
        InputAndCodeFilterModule,
        NumberFilterModule,
        DateFilterModule,
        SettlementDetailModule,
        SegmentedButtonModule
    ],
    exports: [SettlementsMainPageComponent]
})
export class SettlementsMainPageComponentModule {
}
